import { useQuery } from '@apollo/client';

import GetDailyQuestionUserScore from 'graphql/gamification/queries/dailyQuestionUserScore.graphql';

import { GetDailyQuestionUserScoreQuery } from 'graphql/types';

export const useDailyQuestionUserScore = (competitionSlug: string) =>
  useQuery<GetDailyQuestionUserScoreQuery>(GetDailyQuestionUserScore, {
    variables: { competitionSlug },
  });
